import React from 'react';

const MissionalRangeBar = ({ min = -10, max = 9 }) => {
  // Define exact color for each position on the scale
  const positionColors = {
    '-10': '#0076BE', // Deepest blue
    '-9': '#0079C1',
    '-8': '#007CC4',
    '-7': '#007FC7', // Transitioning to green
    '-6': '#1C8B41',
    '-5': '#2E943C',
    '-4': '#3F9D37',
    '-3': '#51A632',
    '-2': '#62AF2D',
    '-1': '#74B828',
    '0': '#85C123',   // Pure green
    '1': '#96CA1E',   // Starting to yellow
    '2': '#A8D319',
    '3': '#B9DC14',
    '4': '#CBE50F',
    '5': '#DCEe0A',
    '6': '#EEF705',
    '7': '#F4F807',
    '8': '#F6F908',
    '9': '#f7e509'    // Pure yellow
  };

  // Get exact color for any position
  const getExactColorForPosition = (position) => {
    // Ensure position is within bounds
    const boundedPosition = Math.max(-10, Math.min(9, position));
    return positionColors[boundedPosition.toString()];
  };

  return (
    <div className="relative w-full">
      {/* Background showing full scale */}
      <div className="h-2 rounded-full bg-gray-200">
        {/* Active range with precise gradient */}
        <div 
          className="h-full rounded-full"
          style={{
            width: '100%',
            background: `linear-gradient(to right, ${getExactColorForPosition(min)}, ${getExactColorForPosition(max)})`
          }}
        />
      </div>
      
      {/* Range labels */}
      <div className="flex justify-between mt-1 text-xs text-gray-600">
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
};

export default MissionalRangeBar; 